/**
 * @license
 * Copyright (c) 2021 - 2026 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */
import { defineCustomElement } from '@vaadin/component-base/src/define.js';
import { IconsetMixin } from './vaadin-iconset-mixin.js';

/**
 * `<vaadin-iconset>` is a Web Component for creating SVG icon collections.
 *
 * @customElement vaadin-iconset
 * @extends HTMLElement
 */
class Iconset extends IconsetMixin(HTMLElement) {
  static get is() {
    return 'vaadin-iconset';
  }
}

defineCustomElement(Iconset);

export { Iconset };
